var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p"},[(_vm.url)?_c('el-avatar',{staticClass:"wx-avatar",attrs:{"src":_vm.profile(_vm.url),"size":35}}):_c('img',{attrs:{"src":require("../assets/imgs/unlogin.svg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }